import ReactDOM from "react-dom";
import PropTypes from "prop-types";

export const Portal = ({ node, children }) => {
  if (node === null) return null;
  return ReactDOM.createPortal(children, node);
};

Portal.propTypes = {
  node:
    typeof Element !== "undefined"
      ? PropTypes.instanceOf(Element)
      : PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Portal.defaultProps = {
  node: typeof document === "undefined" ? null : document.body,
};

Portal.displayName = "Portal";

export default Portal;
